@if (!model.isModal) {
  <h6 *ngIf="!model.editMode" i18n="@@Creating"><a [routerLink]="model.getAbsolutePath()">{{ model.getTitle(true) }}</a> / {{ translations.add }}</h6>
  <h6 *ngIf="model.editMode" i18n="@@Updating">
    <a [routerLink]="model.getAbsolutePath()">{{ model.getTitle(true) }}</a>
    <span *ngIf="model.editName">  / {{ model.editName }}  </span>
  </h6>
}

<div *ngIf="model.deleted">
  <span class="text-bg-secondary" i18n="@@RecordDeletedNoTags">Запись удалена</span>
  <button (click)="model.restore()" *ngIf="model.deleted" i18n-nbTooltip="@@Restore" nbButton nbTooltip="Восстановить" status="control">
    <nb-icon icon="repeat-outline"/>
  </button>
</div>
